<script>
  export let cards = {}
  export let keys = []

  function toneClass(c) {
    const t = (c && c.tone) || 'gray'
    if (t === 'green') return 'pm-card--green'
    if (t === 'red') return 'pm-card--red'
    if (t === 'yellow') return 'pm-card--yellow'
    return ''
  }
</script>

<section class="pm-cards" aria-label="Сводка">
  {#each keys as key}
    {#if cards[key]}
      {@const c = cards[key]}
      <article class="pm-card {toneClass(c)}" data-card={key}>
        <span class="pm-card-label">{c.title || key}</span>
        <span class="pm-card-value">{c.value ?? '—'}</span>
        {#if c.sub}
          <span class="pm-card-sub">{c.sub}</span>
        {/if}
      </article>
    {/if}
  {/each}
</section>
